export default __webpack_public_path__ + "static/media/moenime.bf91da75.gif";